<script setup>
import { onBeforeUnmount, onMounted, computed, watch, ref } from 'vue'
import { useTranslaterStore } from '@/stores/translater'

const props = defineProps({
    header: {
        type: String,
        required: true
    },
    fieldsRequired: {
        type: Boolean
    },
    size: {
        type: String,
        required: false
    },
    show: {
        type: Boolean
    }
})

const emit = defineEmits([
    'closeModal'
])

const translaterStore = useTranslaterStore()
const getTranslate = computed(() => translaterStore.getTranslate)
const modal = ref(null)
const show = computed(() => props.show)

onMounted(() => {

    const modalWrapper = document.getElementsByClassName('uta-modal__wrapper')[0]
    const modalBody = document.getElementsByClassName('uta-modal__container')[0]
    const scrollbarWidth = window.innerWidth - document.body.offsetWidth

    document.body.style.overflow = show.value ? 'hidden' : ''
    document.body.style.paddingRight = show.value ? scrollbarWidth + 'px' : ''

    // Переносим модальное окно в корень body [головняк с позиционированием = disable]
    modal.value = document.getElementsByClassName('uta-modal__mask')[0]
    document.body.appendChild(modal.value)

    // Клик вне модального окна закрывает его
    modalWrapper.addEventListener('mousedown', event => {

        if(!modalBody.contains(event.target)) {

            emit('closeModal', true)
        }
    })

    // Закрытие модального окна по нажатию Esc
    document.addEventListener('keyup', event => event.code == "Escape" ? emit('closeModal', true) : null )
}) 

onBeforeUnmount(() => {

    document.body.style.overflow = ''
    document.body.style.paddingRight = ''

    document.body.removeChild(modal.value)
}) 

watch(show, mode => {
    
    if(mode) {

        const scrollbarWidth = window.innerWidth - document.body.offsetWidth

        document.body.style.overflow = mode ? 'hidden' : ''
        document.body.style.paddingRight = mode ? scrollbarWidth + 'px' : ''
    }
})

</script>

<template>
    <div class="uta-modal__mask">
        <div class="uta-modal__wrapper">
            <div 
                class="uta-modal__container" 
                :class="{ 
                    'uta-modal__container--md' : size && size == 'md',
                    'uta-modal__container--lg' : size && size == 'lg',
                    'uta-modal__container--xl' : size && size == 'xl'
                }
            ">
                <div class="uta-modal__header">
                    <slot name="header">
                        <div class="uta-modal__header-text">
                            {{ header }}
                        </div>
                        <div class="uta-modal__header-subtext d-none d-md-block" v-if="fieldsRequired">
                            <span class="uta-modal__header-warning">⚹</span> {{ getTranslate.FORM_REQUIRED }}
                        </div>
                    </slot>
                    <div class="uta-modal__header-close material-icons" @click="emit('closeModal', true)">
                        clear
                    </div>
                </div>
                <div class="uta-modal__body">
                    <slot name="body"></slot>
                </div>
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/modal.scss';
</style>